import React from 'react';

export const NumberCell = (props: any) => {
  return <td style={{textAlign: 'right'}}>{props.dataItem[props.field]}</td>;
};
